import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser"
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode"
import { UnavailabilityReason } from "../../../../../../Wrap/Constants/Enums/Domain/UnavailabilityReason"
import { ConvertCappedToFlexiModel } from "../../../../../../Wrap/Models/Models/Processes/Drawdown/ConvertCappedToFlexiModel"

export const convertToFlexiStepperName = {
    selectArrangement: "Select arrangements to convert",
    review: "Review",
    confirmation: "Confirmation"
}

export const SelectArrangementInformationText = {
    warningMessageHeading : "Important information",
    warningMessageBody: "You can find out more about when we can convert an account and details of what happens once the conversion takes place.",
    popUpMessage: "Placeholder here"
}

export const ReviewStepInformationText = 
"We will convert each drawdown account into its own flexi account, retaining the existing capped account number for each."

export const AdviserDeclaractionText = {
    messagePart1 : "I can confirm on behalf of ",
    messagePart2: " that my client has instructed the conversion to a flexi account."
}

export const unavailabilityReasonsMap = {
    [UnavailabilityReason.IncomeWithdrawalInProgress]: "Payment of income withdrawal in progress",
    [UnavailabilityReason.ZeroAssetOrCashBalance]: "No account value",
    [UnavailabilityReason.OrdersInProgress]: "Trade(s) in progress",
}
